const services = [
  {
    id: "2",
    img: "/new_img/scaffolding.webp",
    img2: "/new_img/scaffolding-service.png",
    title: "Scaffolding Services",
    title2: "Scaffolding Services",
    paragraph:
      "We produce positive results from growing Industrial estates, we have established a corporate or mandate to maintain the manufacturing economy...",
    body: (
      <div className="ServicePage2_area">
        <div className="ServicePage2_area_cont">
          We produce positive results from growing Industrial estates, we have
          established a corporate or mandate to maintain the manufacturing
          economy.
        </div>
        <div className="ServicePage2_area_cont">
          Our scaffolding solutions are tailored for diverse industrial needs,
          encompassing erecting, dismantling, design, engineering, and rentals.
          We specialize in industrial scaffolding, shoring, formwork, and access
          towers, ensuring the highest safety standards.
        </div>

        <br />

        <div className="ServicePage2_area_cont">
          <p className="font-bold ">Scaffolding Services;</p>
          <ol>
            <li>Erection and Dismantling</li>
            <li>Scaffolding Rental</li>
            <li>Industrial Scaffolding</li>
            <li>Shoring and Formwork</li>

            <li>Access Towers and Mobile Scaffolding</li>
            <li>Scaffolding Safety Inspections</li>
          </ol>
        </div>
      </div>
    ),
  },
  {
    id: "3",
    img: "/new_img/fabrication-service.png",
    img2: "/new_img/fabrication-service.png",

    title: "Fabrication Services",
    title2: "Fabrication Services",
    paragraph:
      "We excel in metal fabrication, offering services like welding and surface finishing. Our expertise ensures precision and quality in every project.",
    body: (
      <div className="ServicePage2_area">
        <div className="ServicePage2_area_cont">
          With innovation scaftech has earned a reputation in welding and
          interpretation of clients requirements. Our every welding jobs comes
          with extinct professionalism. We offer free consultation and 360
          turntable quality service solution from scratch to finish.
        </div>
        <br />
        <div className="ServicePage2_area_cont">
          We excel in metal fabrication, offering services like welding and
          surface finishing. Our expertise ensures precision and quality in
          every project.
          <br />
          Our approach to fabrication involves meticulous planning and the use
          of advanced technology, allowing us to deliver cost-effective and
          customized solutions that meet the exact needs of our clients
        </div>

        <div className="ServicePage2_area_cont">
          <p className="font-bold ">Fabrication Services;</p>
          <ol>
            <li>Metal Fabrication</li>
            <li>Welding and Joining of Steel & Pipe Flow Line</li>
            <li>Surface Finishing</li>
          </ol>
        </div>
      </div>
    ),
  },
  {
    id: "4",
    img: "/new_img/inspection-service.png",
    img2: "/new_img/inspection-service.png",

    title: "Inspection Services",
    title2: "Inspection Services",
    paragraph:
      "We are an ISO 45001:2018 accredited by DPR and federal ministry of labour in Nigeria for testing...",
    body: (
      <div className="ServicePage2_area">
        <div className="ServicePage2_area_cont">
          We are an ISO 45001:2018 accredited by DPR and federal ministry of
          labour in Nigeria for testing, calibration and inspection company
          offering services to oil, gas and allied industries
        </div>
        <br />
        <div className="ServicePage2_area_cont">
          3rd Party Statutory Inspection as per government regulatory law and
          safety measures we provide comprehensive equipment and lifting hoist
          inspections, Equipment Load testing, Non-destructive testing.
          Onsite/workplace safety inspection aligning with occupational health
          and safety standards and LEEA.
        </div>
        <br />
        <div className="ServicePage2_area_cont">
          Our inspection process is thorough and efficient, utilizing the latest
          techniques and equipment to ensure the highest level of safety and
          compliance
        </div>
        <br />

        <div className="ServicePage2_area_cont">
          <p className="font-bold ">Inspection Services;</p>
          <ol>
            <li>Equipment and Lifting Hoist Inspection</li>
            <li>Equipment Load Testing</li>

            <li>Non-Destructive Testing (NDT) </li>
            <li>Onsite/Workplace Safety Inspection</li>
          </ol>
        </div>
        <div className="ServicePage2_area_cont"></div>
        <br />
        <div className="ServicePage2_area_cont"></div>
      </div>
    ),
  },

  {
    id: "5",
    img: "/new_img/training-program.png",
    img2: "/new_img/training-program.png",
    title: "Training Programs",
    title2: "Training Programs",
    paragraph:
      "We offer recertification and a wide range of training services, fostering a culture of safety and competence...",
    body: (
      <>
        <div>
          We offer recertification and a wide range of training services,
          fostering a culture of safety and competence. Our programs cover areas
          such as construction safety, first aid, fire safety and to a diverse
          range of professionals, including riggers, equipment operators,
          scaffolders and others involved in the construction, industrial and
          engineering sectors.
        </div>

        <div className="ServicePage2_area_cont">
          Our training modules are constantly updated to reflect the latest
          industry trends and practices, providing participants with the skills
          and knowledge to excel in their respective fields
        </div>

        <br />

        <div className="ServicePage2_area_cont">
          <p className="font-bold ">Training Services</p>
          <ol>
            <li>Equipment Operator Traning </li>
            <li>Scaffolding Training</li>
            <li>Riggers & Banksman Training</li>
            <li>Refresher Safety Training </li>
            <li>First Aid Training</li>
            <li>Fire Safety Training </li>
            <li>Recertification Training</li>
          </ol>
        </div>
      </>
    ),
  },

  {
    id: "7",
    img: "/new_img/maintenance-service.png",
    img2: "/new_img/maintenance-service.png",
    title: "Maintenance Services",
    title2: "Maintenance Services",
    paragraph:
      "Our maintenance services comprehensively address both equipment and facility needs, including routine, preventive, corrective, and predictive maintenance.",
    body: (
      <div className="ServicePage2_area">
        <div className="ServicePage2_area_cont">
          Our maintenance services comprehensively address both equipment and
          facility needs, including routine, preventive, corrective, and
          predictive maintenance. This holistic approach ensures minimal
          downtime and extends equipment lifespan, offering cost-effective
          solutions and enhanced operational efficiency. Facility maintenance
          encompasses essential services like cleaning, landscaping, plumbing,
          and HVAC maintenance, ensuring a well-maintained, efficient
          environment for our clients.
        </div>
        <br />
        <div className="ServicePage2_area_cont">
          Begin with a consultation, progress through tailored solutions. Our
          formula: Understand, Plan, Execute. Your advantage: A facility /
          maintenance service that functions flawlessly.
        </div>

        <div className="ServicePage2_area_cont">
          <p className="font-bold ">Maintenance Solutions </p>
          <ol>
            <li>Facility Maintenance </li>
            <li>Equipment Maintenance</li>
            <li>Equipment Repairs</li>
          </ol>
        </div>
      </div>
    ),
  },

  {
    id: "9",
    img: "/new_img/rooftop-fall.png",
    img2: "/new_img/rooftop-fall.png",
    title: "Rooftop Fall Protection",
    title2: "Rooftop Fall Protection",
    paragraph:
      "Our services encompass a comprehensive range of solutions, including advanced rooftop anchorage systems....",
    body: (
      <div className="ServicePage2_area">
        <div className="ServicePage2_area_cont">
          Our services encompass a comprehensive range of solutions, including
          advanced rooftop anchorage systems, state-of-the-art fall arrest
          systems, and robust guardrail systems. We understand that each rooftop
          is unique, and so are our clients safety needs. That's why our
          approach is deeply personalized – we customize our services to align
          seamlessly with clients specific requirements, ensuring unparalleled
          safety without hindering their day-to-day operations.
        </div>
        <br />
        <div className="ServicePage2_area_cont">
          Our team of experts is dedicated to delivering not just solutions, but
          peace of mind
        </div>
        <br />
        <div className="ServicePage2_area_cont">
          <p className="font-bold ">Full Protection Services </p>
          <ol>
            <li>Rooftop Anchorage Systems </li>
            <li>Fall Arrest Systems </li>
            <li>Guardrails Systems </li>
          </ol>
        </div>
      </div>
    ),
  },
];
export default services;
